module.exports = __webpack_public_path__ + "img/audio-back.8df7430a.gif";